module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"CENTERS":"Schools","STUDENTS":"Students","BUSES":"Buses","DRIVERS":"Drivers","ABSENCES":"Absences","ROUTES":"Routes","SUPERVISORS":"Supervisors","TOTAL":"Total"},"ar":{"CENTERS":"مراكز","STUDENTS":"الطلاب","BUSES":"الحافلات","DRIVERS":"السائقين","ABSENCES":"غياب","ROUTES":"خط السير","SUPERVISORS":"المشرفات","TOTAL":"مجموع"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/MasterDashboard.vue
// module id = 298
// module chunks = 1